import { action, makeAutoObservable, observable } from "mobx";
import { RootStore } from ".";
import { getAllConcertEvents, getConcertTicketsByEvaXML, getConcertTicketsByEventPaged, sendInforUByChannelAndActionBulk, updateCostumersData } from "../fetchers/concert";
import { TicketMessageAction, TicketMessageChannel } from "../pages/concertTickets/TicketMessageDialog";

class ConcertStore {
  private _rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    makeAutoObservable(this);
  }

  @observable
  events: any = [];

  @observable
  event: any = null;

  @observable
  tickets: any = [];

  @observable
  totalRecordsInDB: number = 0;

  @observable
  totalFilteredRecords: number = 0;

  @observable
  isLoading: boolean = false;

  @action
  setEvents = (events: any) => {
    this.events = events;
  };

  @action
  setEvent = (event: any) => {
    this.event = event;
  };

  @action
  setTotalRecordsInDB = (totalRecordsInDB: number) => {
    this.totalRecordsInDB = totalRecordsInDB;
  };

  @action
  setTotalFilteredRecords = (totalFilteredRecords: number) => {
    this.totalFilteredRecords = totalFilteredRecords;
  };

  @action
  setTickets = (tickets: any) => {
    this.tickets = tickets;
  };

  @action
  fetchEvents = async (from?: string, to?: string) => {
    this.isLoading = true;
    try {
      const data = await getAllConcertEvents(from, to);
      this.setEvents(data);
    } catch (error) {
      console.log("fetchEvents error", error);
      this.setEvents([]);
    } finally {
      this.isLoading = false;
    }
  }

  @action
  fetchTicketsByEventPaged = async (eventId: number, page: number, pageSize: number, search: string, sendStatus: string[], missingOnly: boolean) => {
    this.isLoading = true;
    try {
      const result = await getConcertTicketsByEventPaged(eventId, page, pageSize, search, sendStatus, missingOnly);
      this.setTickets(result.data || []);
      this.setTotalRecordsInDB(result.totalAll || 0);
      this.setTotalFilteredRecords(result.totalFiltered || 0);
    } catch (error) {
      console.log("fetchTicketsByEventPaged error", error);
      this.setTickets([]);
      this.setTotalRecordsInDB(0);
    } finally {
      this.isLoading = false;
    }
  };

  @action
  fetchTicketsByEvaXMLPaged = async (eventId: number, page: number, pageSize: number, search: string, sendStatus: string[], missingOnly: boolean) => {
    this.isLoading = true;
    try {
      const result = await getConcertTicketsByEvaXML(eventId, page, pageSize, search, sendStatus, missingOnly);
      this.setTickets(result.data || []);
      this.setTotalRecordsInDB(result.totalAll || 0);
      this.setTotalFilteredRecords(result.totalFiltered || 0);
    } catch (error) {
      console.log("fetchTicketsByEventPaged error", error);
      this.setTickets([]);
      this.setTotalRecordsInDB(0);
    } finally {
      this.isLoading = false;
    }
  };

  @action
  fetchTicketsByEvaXML = async (eventId: number, page: number, pageSize: number, search: string, sendStatus: string[], missingOnly: boolean) => {
    this.isLoading = true;
    try {
      const result = await getConcertTicketsByEvaXML(eventId, page, pageSize, search, sendStatus, missingOnly);
      this.setTickets(result.data || []);
      this.setTotalRecordsInDB(result.totalAll || 0);
      this.setTotalFilteredRecords(result.totalFiltered || 0);
    } catch (error) {
      console.log("fetchTicketsByEventPaged error", error);
      this.setTickets([]);
      this.setTotalRecordsInDB(0);
    } finally {
      this.isLoading = false;
    }
  };

  @action
  updateCostumersData = async (patches: any[]) => {
    this.isLoading = true;
    try {
      const data = await updateCostumersData(patches);
      return data;
    } catch (error) {
      console.log("updateCostumersData error", error);
      return Promise.reject(error);
    } finally {
      this.isLoading = false;
    }
  };

  @action
  sendInforUByChannelAndActionBulk = async (barcodes: string[], channel: TicketMessageChannel, action: TicketMessageAction) => {
    this.isLoading = true;
    try {
      const data = await sendInforUByChannelAndActionBulk(barcodes, channel, action);
      return data;
    } catch (error) {
      console.log("sendInforUByChannelAndActionBulk error", error);
      return Promise.reject(error);
    } finally {
      this.isLoading = false;
    }
  };
}

export default ConcertStore;
